export function useKeycloak() {
  const logout = () => {
    const logoutUrl = (window as any).keycloak.createLogoutUrl();
    window.location.replace(logoutUrl);
  };

  return {
    keycloak: (window as any).keycloak,
    logout,
    email: () => (window as any).keycloak?.tokenParsed?.email ?? '',
  };
}
